/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteContainerCommand } from '../../models/delete-container-command';
import { DeleteContainerCommandResult } from '../../models/delete-container-command-result';

export interface ApiContainersDeleteContainerDelete$Params {
      body?: DeleteContainerCommand
}

export function apiContainersDeleteContainerDelete(http: HttpClient, rootUrl: string, params?: ApiContainersDeleteContainerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteContainerCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersDeleteContainerDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteContainerCommandResult>;
    })
  );
}

apiContainersDeleteContainerDelete.PATH = '/api/Containers/DeleteContainer';
